<template>
  <div class="page_content explore_entity_inside career" aria-label="Career Streams Page">
    <div class="row page-heading">
      <div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading">
        <div class="module_icon ico-career"></div>
        <template v-if="career && career.name">
          <career-title :career="career"></career-title>
        </template>
      </div>
      <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 px-0">
        <!--
        <b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
          <template slot="button-content">
            <span class="icon-menu3x3"></span>
          </template>
        </b-dropdown>
        -->
        <div class="btn_container" v-if="showBackToResultButton">
          <b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
            <span class="btn_ic ic-back"></span>
            <span class="btn_txt"> {{ deCamelCase() }} </span>
          </b-btn>
        </div>
      </div>
    </div>
    <div class="page_content_container">
      <career-navigation :active="'streams'" :code="code" :cipCode="cipCode" :returnTo="returnTo"></career-navigation>
      <div class="pg_content grid_view">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
          <div class="row pg_sec">
            <div v-if="streamsToShow && streamsToShow.length > 0" class="col-12">
              <template v-for="stream in streamsToShow">
                <div class="row lst_row">
                  <div class="col-2 thumbnail_container ace_sec" @click.stop.prevent="goToStreamPage(stream)">
                    <!--
                      <div class="thumbnail_img">
                        <img v-bind:src="" alt="Img">
                      </div>
                      -->
                    <div class="thumbnail_default" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
                      <div class="txt_bx" v-html="setTitleInitials(streamTitle(stream))"></div>
                    </div>
                  </div>
                  <div class="col-10 entity_detail_section">
                    <div class="row">
                      <div class="col-12 title">
                        <span class="title_txt">
                        <a href="#" @click.stop.prevent="goToStreamPage(stream)">
                        {{streamTitle(stream)}}
                        </a>
                        </span>
                        <template v-if="isBookmarked(stream)">
                          <span @click.stop.prevent="deleteStreamBookmark(stream)" class="ace_sec_txt ic ic8-bookmark3 bookmarked" title="remove this stream from bookmark"></span>
                        </template>
                        <template v-else-if="!isBookmarked(stream)">
                          <span @click.stop.prevent="bookmarkStream(stream)" class="ace_sec_txt ic ic8-bookmark3" title="bookmark alumni stream"></span>
                        </template>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 other_details">
                        {{stream.description}}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <!-- ==== Old Grid UI - Change to list view on 20 April 2021 ==== -->
              <!--
              <div class="row content_row" style="display: none;">
                <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12 content_block" v-for="stream in streamsToShow">
                  <div class="content_block_inner" tabindex="0" :aria-label="streamTitle(stream)">
                    <div class="thumbnail" @click.stop.prevent="goToStreamPage(stream)" role="button" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
                      <div class="txt_bx" v-html="setTitleInitials(streamTitle(stream))"></div>
                    </div>
                    <div class="title_container">
                      <span class="icon icon-stream"></span>
                      <span class="title_new ace_sec_txt" :aria-label="streamTitle(stream)">
                        <v-clamp class="title_txt" @click.stop.prevent="goToStreamPage(stream)" autoresize :max-lines="2">{{streamTitle(stream)}}</v-clamp>
                      </span>
                      <template v-if="isBookmarked(stream)">
                        <span @click.stop.prevent="deleteStreamBookmark(stream)" class="ace_sec_txt icon icon-bookmark bookmarked" title="remove this stream from bookmark"></span>
                      </template>
                      <template v-else-if="!isBookmarked(stream)">
                        <span @click.stop.prevent="bookmarkStream(stream)" class="ace_sec_txt icon icon-bookmark" title="bookmark alumni stream"></span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              -->
            </div>
            <div v-else class="col-12">
              <!--
              <div class="col-12 hd ace_sec_hd" aria-label="Streams">
                <h2>Streams</h2>
                <span class="hd_bdr"></span>
              </div>
              -->
              <div class="msg_no_data empty_pattern">
                This career doesn't have any pathways.
              </div>
              </div>
            </div>
            <!-- .pg_sec -->
          </div>
          <!-- .content_mid_panel -->
        </div>
        <!-- .pg_content -->
      </div>
      <!-- .page_content_container -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CareerTitle from './CareerTitle'
import CareerNavigation from './CareerNavigation'
import VClamp from 'vue-clamp'

export default {
  name: 'careerStreams',
  props: ['code', 'cipCode', 'returnTo', 'showBackToResultButton'],
  components: {
    CareerTitle,
    CareerNavigation,
    VClamp
  },
  data: () => {
    return {
      userId: localStorage.getItem('userid'),
      career: {},
      DEFAULT_RETURN_TO: 'exploreCareerResults',
      EXPLORE_RESULTS: 'exploreCareerResults'
    }
  },

  async mounted () {
    await this.loadAllBookmarks()
    await this.loadDataForCareerStreams()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'loadAlumniStreamRecommendations',
      'loadAdvisorStreamRecommendations',
      'loadCareer',
      'loadAllBookmarks',
      'loadDeleteBookmark',
      'loadCreateBookmarks'
    ]),
    async loadDataForCareerStreams () {
      this.career = await this.loadCareer({ code: this.code, loadDataFromServer: true })
      this.loadLogDashboardActivity({action: 'viewCareerStreams', page: 'careerStreams', link: '', careerSocCode: this.code})
      let alumniRecommendationData = this.buildAlumniStreamRecommendationData(this.career)
      let advisorRecommendationData = this.buildAdvisorStreamRecommendationData(this.career)
      this.loadAlumniStreamRecommendations({ recommendationData: alumniRecommendationData })
      this.loadAdvisorStreamRecommendations({ recommendationData: advisorRecommendationData })
    },
    parseTerms (sourceList) {
      if (!sourceList || !sourceList.length) {
        return []
      }
      let targetList = []
      sourceList.forEach((item, i) => {
        let curr = JSON.parse(item)
        targetList.push(curr.name)
      })
      return targetList
    },
    buildAlumniStreamRecommendationData (career) {
      let data = {
        'title': career.name,
        'socCode': career.code,
        'topCompanies': this.parseTerms(career.topPostingCompanies),
        'topSkills': this.parseTerms(career.skills),
        'majors': (career.majors) ? career.majors : [],
        'departments': (career.departments) ? career.departments : [],
        'category': career.category || ''
      }
      return data
    },
    buildAdvisorStreamRecommendationData (career) {
      let data = {
        'requestType': 'career',
        'relatedCipCodes': career.cipCodes
      }
      return data
    },
    goToStreamPage (stream) {
      let uuid = (stream.streamId) ? stream.streamId : stream.uuid
      return this.$router.push({ name: 'streamTime', params: { uuid: uuid } })
    },
    streamTitle (stream) {
      let title = (stream.title) ? stream.title : stream.streamTitle
      return title
    },
    setTitleInitials (streamTitle) {
      let getTitleInitials = streamTitle.match(/\b(\w)/g)
      if (getTitleInitials) { return getTitleInitials.join('') } else {
        return 'P'
      }
    },
    setThumbnailBgColor (entityId) {
      let getNumricValue = entityId.replace(/[^0-9]/g, '')
      return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
    },
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to career results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    },
    getStreamBookmark (stream) {
      let bookmarks = this.bookmarks
      if (!bookmarks || !bookmarks.length) {
        return false
      }
      let target = false
      bookmarks.forEach(bookmark => {
        if (bookmark.entityUuid === stream.uuid) {
          target = bookmark
        }
      })
      return target
    },
    isBookmarked (stream) {
      return stream.bookmark && stream.bookmark.uuid
    },
    async bookmarkStream (stream) {
      const bookmark = {
        'source': 'explore',
        'entityType': 'stream',
        'entityTitle': stream.title,
        'entityUuid': stream.uuid,
        'userId': this.userId
      }
      const response = await this.loadCreateBookmarks(bookmark)
      const message = (response ? 'Successfully bookmarked \'' : 'Unable to bookmark \'') + stream.title + '\''
      const notify = response ? this.notifySuccess : this.notifyFailure
      notify(message)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Stream as bookmarked
    },
    async deleteStreamBookmark (stream) {
      await this.loadDeleteBookmark(stream.bookmark.uuid)
      await this.loadAllBookmarks() // Refresh Vuex state to mark Stream as bookmarked
    },
    notifySuccess (text) {
      return this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      return this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    }
  },

  computed: {
    ...mapState({
      'alumniStreamRecommendations': state => state.stream.alumniStreamRecommendations,
      'advisorStreamRecommendations': state => state.stream.advisorStreamRecommendations,
      'bookmarks': state => state.explore.bookmarks
    }),
    streamsToShow () {
      let advisorStreams = this.advisorStreamRecommendations
      let alumniStreams = this.alumniStreamRecommendations
      let isAdvisorStreamsEmpty = !advisorStreams || !advisorStreams.length
      let isAlumniStreamsEmpty = !alumniStreams || !alumniStreams.length
      if (isAdvisorStreamsEmpty && isAlumniStreamsEmpty) {
        return []
      }
      let streamsToShow = []
      if (!isAdvisorStreamsEmpty) {
        streamsToShow = advisorStreams
      }
      if (!isAlumniStreamsEmpty) {
        streamsToShow = streamsToShow.concat(alumniStreams)
      }
      let getStreamBookmark = this.getStreamBookmark
      streamsToShow.forEach(stream => {
        stream.bookmark = getStreamBookmark(stream)
      })
      return streamsToShow
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerStreams.vue